






































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Watch } from "vue-property-decorator";
import { storeSupervisiLimbah } from "@/store/modules/SupervisiLimbahStore";
import SupervisiLimbahSvc from "@/services/SupervisiLimbahService";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import {
  SupervisiLimbahChecklistRow,
  SupervisiLimbahHasil,
  SupervisiLimbahItem
} from "@/types/SupervisiLimbah";

@Component({ components: { CardModalTtd, VCDateTimePicker } })
export default class SupervisiLimbahFormPage extends Vue {
  parent = {
    nomor_formulir: "" as string | null,
    tanggal_supervisi: localISODate(),
    kepala_unit_nama_manual: "",
    kesimpulan: ""
  };
  itemsDraft: SupervisiLimbahItem[] = [];
  saving = false;
  showTtdModal = false;
  signRole: "supervisor" | "kepala-unit" = "supervisor";

  get routeId() {
    return this.$route.params.id;
  }

  get isNew() {
    return this.routeId === "baru";
  }

  get current() {
    return this.isNew ? null : storeSupervisiLimbah.currentItem;
  }

  get locked() {
    return !!(this.current && this.current.is_locked);
  }

  get canCreate() {
    return userModule.hasPrivilege("supervisi_limbah", "create");
  }

  get canEdit() {
    return userModule.hasPrivilege("supervisi_limbah", "update");
  }

  get editable() {
    if (this.isNew) return this.canCreate;
    return this.canEdit && !this.locked;
  }

  get isSupervisor() {
    return !!(this.current && this.current.supervisor_user_id === userModule.user?.id);
  }

  get signHint() {
    if (!this.current || !this.canEdit || this.locked) return "";
    if (!this.current.signed_supervisor && !this.isSupervisor) {
      return "TTD IPCN hanya dapat dilakukan oleh IPCN yang membuat supervisi ini.";
    }
    if (this.current.signed_supervisor && this.isSupervisor) {
      return "TTD Koordinator dilakukan oleh Koordinator Pengelolaan Limbah dengan akunnya sendiri.";
    }
    return "";
  }

  get checklistRows(): SupervisiLimbahChecklistRow[] {
    const groups: { kategori: string; label: string; items: SupervisiLimbahItem[] }[] = [];
    this.itemsDraft.forEach(item => {
      const last = groups[groups.length - 1];
      if (last && last.kategori === item.kategori) {
        last.items.push(item);
      } else {
        groups.push({ kategori: item.kategori, label: item.kategori_label, items: [item] });
      }
    });
    const rows: SupervisiLimbahChecklistRow[] = [];
    groups.forEach((group, groupIdx) => {
      group.items.forEach((item, idx) => {
        rows.push({
          item,
          groupNo: groupIdx + 1,
          indikator: group.label,
          isFirst: idx === 0,
          groupSize: group.items.length
        });
      });
    });
    return rows;
  }

  get supervisorName() {
    if (this.current) {
      return (this.current.supervisor && this.current.supervisor.nama) || "";
    }
    return userModule.user?.nama || "";
  }

  get koordinatorName() {
    if (!this.current) return "";
    if (this.current.kepala_unit && this.current.kepala_unit.nama) {
      return this.current.kepala_unit.nama;
    }
    return this.current.kepala_unit_nama_manual || "";
  }

  get tanggalSupervisiDate(): Date | null {
    return composeDate(this.parent.tanggal_supervisi);
  }
  set tanggalSupervisiDate(val: Date | null) {
    this.parent.tanggal_supervisi = toDateString(val) || "";
  }

  mounted() {
    if (!this.isNew) {
      this.load();
    }
  }

  @Watch("$route.params.id")
  onRouteIdChange(newId: string) {
    if (newId && newId !== "baru") {
      this.load();
    }
  }

  async load() {
    storeSupervisiLimbah.SET_CURRENT_ITEM(null);
    this.itemsDraft = [];
    await storeSupervisiLimbah.refresh(Number(this.routeId));
    const current = this.current;
    if (current && String(current.id) === this.routeId) {
      this.parent = {
        nomor_formulir: current.nomor_formulir,
        tanggal_supervisi: current.tanggal_supervisi,
        kepala_unit_nama_manual: current.kepala_unit_nama_manual || "",
        kesimpulan: current.kesimpulan || ""
      };
      this.itemsDraft = (current.items || []).map(i => ({ ...i }));
    }
  }

  async saveNew() {
    this.saving = true;
    try {
      const resp = await SupervisiLimbahSvc.create({
        tanggal_supervisi: this.parent.tanggal_supervisi,
        kepala_unit_nama_manual: this.parent.kepala_unit_nama_manual || null
      });
      const id = resp.data.data.id;
      this.$router.replace({ name: "supervisi-limbah-form", params: { id: String(id) } });
    } finally {
      this.saving = false;
    }
  }

  async persistDraft() {
    if (!this.current) return;
    const payload: {
      tanggal_supervisi: string;
      kesimpulan: string | null;
      kepala_unit_nama_manual?: string | null;
    } = {
      tanggal_supervisi: this.parent.tanggal_supervisi,
      kesimpulan: this.parent.kesimpulan || null
    };
    if (!this.current.signed_kepala_unit) {
      payload.kepala_unit_nama_manual = this.parent.kepala_unit_nama_manual || null;
    }
    await SupervisiLimbahSvc.update(this.current.id, payload);
    await SupervisiLimbahSvc.updateItems(
      this.current.id,
      this.itemsDraft.map(i => ({
        id: i.id,
        hasil: i.hasil || null,
        masalah: i.masalah || null,
        rekomendasi: i.rekomendasi || null
      }))
    );
  }

  async saveDraft() {
    this.saving = true;
    try {
      await this.persistDraft();
      appModule.sendSuccessNotice("Draft supervisi tersimpan");
      await this.load();
    } finally {
      this.saving = false;
    }
  }

  openSign(role: "supervisor" | "kepala-unit") {
    this.signRole = role;
    this.showTtdModal = true;
  }

  async onSignPassword(password: string) {
    if (!this.current) return;
    const id = this.current.id;
    this.saving = true;
    try {
      if (!this.locked) {
        await this.persistDraft();
      }
      if (this.signRole === "supervisor") {
        await SupervisiLimbahSvc.signSupervisor(id, { password });
      } else {
        await SupervisiLimbahSvc.signKepalaUnit(id, { password });
      }
      appModule.addMsgTtd("");
      await this.load();
    } catch (e) {
      const msg = (e as any)?.response?.data?.message || "Gagal menandatangani";
      appModule.addMsgTtd(msg);
      this.showTtdModal = true;
    } finally {
      this.saving = false;
    }
  }

  hasilText(hasil: SupervisiLimbahHasil) {
    if (hasil === "ya") return "Ya";
    if (hasil === "tidak") return "Tidak";
    return "Belum dinilai";
  }

  hasilClass(hasil: SupervisiLimbahHasil) {
    if (hasil === "ya") return "success--text font-weight-bold";
    if (hasil === "tidak") return "error--text font-weight-bold";
    return "grey--text";
  }

  printPdf() {
    if (this.current) SupervisiLimbahSvc.printPdf(this.current.id);
  }

  back() {
    this.$router.push({ name: "supervisi-limbah-list" });
  }

  formatDt(dt?: string | null) {
    if (!dt) return "";
    const [tanggal, jam] = dt.split(" ");
    const [y, m, d] = tanggal.split("-");
    return `${d}-${m}-${y} ${(jam || "").substring(0, 5)}`;
  }
}
